import { render, staticRenderFns } from "./FormDate.vue?vue&type=template&id=2dfc414b"
import script from "./FormDate.vue?vue&type=script&lang=ts"
export * from "./FormDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports